import CAButton from '@ds/components/buttons/CAButton'
import CAModal from '@ds/components/containers/CAModal'
import CAInput from '@ds/components/form-elements/CAInput'
import api from '@vuejs/services/api'
import { createFolder } from '@vuejs/services/packages'
import GlobalStore from '@vuejs/stores/GlobalStore'
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'CreateFolder',

	props: { parentFolderId: { optional: true, type: Number } },

	emits: ['created'],

	data(): Data {
		return {
			createFolderName: '',
			isProcessing: false,
		}
	},

	computed: {
		isDisabled(): boolean {
			return !this.createFolderName
		},

		modalName(): string {
			return 'create-content-package-folder-modal'
		},
	},

	methods: {
		closeModal() {
			GlobalStore.resetCAModal()
		},

		async createContentPackageFolder() {
			if (!this.createFolderName) {
				return
			}

			this.isProcessing = true
			try {
				await createFolder(api, {
					name: this.createFolderName,
					parentContentPackageFolderId: this.parentFolderId ?? null,
				})

				GlobalStore.onHandleSuccessMessages({ message: `Content package folder, named "${this.createFolderName}" created` })

				this.closeModal()
				this.$emit('created')
				this.createFolderName = ''
			} catch (error) {
				GlobalStore.onHandleErrorMessages({ error: error instanceof Error ? error.message : String(error) })
			} finally {
				this.isProcessing = false
			}
		},

		showModal() {
			GlobalStore.emittedEvent = this.modalName
		},
	},

	render() {
		return (
			<div>
				<CAButton
					buttonStyle="filled-light"
					dataTest="content-packages-new-folder"
					loading={this.isProcessing}
					text="Create package folder"
					onClick={this.showModal}
				/>

				<CAModal
					alignment="left-aligned"
					disabled={this.isDisabled}
					isOpen={GlobalStore.emittedEvent === this.modalName}
					submitText="Create"
					title="Create package folder"
					onCancel={this.closeModal}
					onSubmit={this.createContentPackageFolder}
				>
					<CAInput
						autofocus={true}
						dataTest="create-new-content-package-folder"
						label="Folder Name"
						labelAppearance="static"
						required={true}
						v-model={this.createFolderName}
						onEnter={this.createContentPackageFolder}
					/>
				</CAModal>
			</div>
		)
	},
})

interface Data {
	createFolderName: string
	isProcessing: boolean
}
